import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { useSetAtom } from "jotai";

import { useToast } from "@whoosh/design-system/src/components/overlay/Toast/useToast";

import { useMutationWithError } from "../../../../../../../utils/hooks/useMutationWithError";
import { GoBackToPreviousVerificationStepAtom } from "../atoms/actions";
import { isVerifyingEmailOrPhoneAtom } from "../atoms/stores";
import { useVerifyAndAssignEmailCodeNotificationsMutation } from "./__generated__/useVerifyAndAssignEmailCodeNotificationsMutation.graphql";

export const useVerifyAndAssignEmailCodeNotifications = () => {
  const [verifyAndAssignEmailCode, isVerifyingAndAssigning] =
    useMutationWithError<useVerifyAndAssignEmailCodeNotificationsMutation>(
      useVerifyAndAssignEmailCodeNotificationsMutationString
    );
  const goBackToInitialStep = useSetAtom(GoBackToPreviousVerificationStepAtom);
  const setVerifyingEmailOrPhone = useSetAtom(isVerifyingEmailOrPhoneAtom);

  const { showToast } = useToast();
  const handleEmailCodeVerification = ({
    email,
    code,
    onComplete,
    onError,
  }: {
    email: string;
    code: string;
    onComplete?: () => void;
    onError: () => void;
  }) => {
    verifyAndAssignEmailCode({
      variables: { input: { email, code } },
      onCompleted: (res) => {
        showToast({
          description: t`Your email address has been updated.`,
          semanticStyle: "success",
          toastId: "email-address-updated",
        });
        goBackToInitialStep();
        setVerifyingEmailOrPhone(null);
        if (onComplete) onComplete();
      },
      onCompletedErrorCustom(errors) {
        onError();
        return errors;
      },
    });
  };
  return [handleEmailCodeVerification, isVerifyingAndAssigning] as const;
};
export const useVerifyAndAssignEmailCodeNotificationsMutationString = graphql`
  mutation useVerifyAndAssignEmailCodeNotificationsMutation(
    $input: VerifyAndAssignEmailInput!
  ) {
    responsePayload: verifyAndAssignEmail(input: $input) {
      success
      errors {
        field
        code
        message
      }
      user {
        id
        email
        ... on MemberUser {
          id
          firstName
          lastName
          email
          phoneNumber {
            nationalNumber
          }
        }
      }
    }
  }
`;
